function storeCache(name, obj) {
  global.cache[name] = { time: new Date() / 1000, data: obj };
  return obj;
}

const _api = {
  SimpleGet: (resource) => new Promise((resolve, reject) => {
    global.Auth.GetRawToken()
      .then(t => {
        fetch(global.apiUrl + resource, {
          method: 'GET',
          headers: new Headers({
            'Accept': 'application/json',
            'Authorization': `Bearer ${t}`
          })
        })
          .then(resolve)
          .catch(reject);
      })
      .catch(reject);
  }),

  Get: (resource, dateProps = [], cacheMaxAgeSec = 0) => new Promise((resolve, reject) => {
    var cached = global.cache[resource];
    if (cached && (new Date() / 1000) - cached.time < cacheMaxAgeSec) {
      resolve(cached.data);
    }
    else {
      _api.SimpleGet(resource)
        .then(resp => resp.ok ? resp.text() : Promise.reject(`Req failed: ${resp.status} (${resp.statusText})`))
        .then(txt => dateProps.length === 0 ?
          JSON.parse(txt) :
          JSON.parse(txt, (key, val) => dateProps.includes(key) ? (val !== null && val !== '' ? new Date(val) : null) : val))
        .then(res => storeCache(resource, res))
        .then(resolve)
        .catch(e => reject(`GET '${resource}' failed: ${e}`));
    }
  }),

  DownloadFile: (resource, filename) => new Promise((resolve, reject) => {
    _api.SimpleGet(resource)
      .then(resp => {
        if (resp.ok) {
          resp.blob()
            .then(b => {
              if (window.navigator && window.navigator.msSaveOrOpenBlob) { // MS Edge support
                window.navigator.msSaveOrOpenBlob(b, filename);
              } else if (window.navigator && window.navigator.userAgent.toLowerCase().indexOf("ipad") !== -1) { // Safari/Chrome? on IOS iPad
                var reader = new FileReader();
                reader.onload = function (e) {
                  window.location.href = reader.result;
                };
                var nb = new Blob([b], { type: 'application/pdf' });
                reader.readAsDataURL(nb);
              } else {
                let blobUrl = window.URL.createObjectURL(new File([b], filename));

                // HACK: creates an invisible download link and clicks it. (The alternative is opening the url in a popup, but those are generally blocked)
                let a = document.createElement('a');
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = blobUrl;
                a.download = filename;
                a.click();

                window.URL.revokeObjectURL(blobUrl);
              }
              resolve();
            })
            .catch(reject);
        } else {
          reject(`Download failed: ${resp.status} (${resp.statusText})`);
        }
      })
      .catch(reject);
  })
};

export default _api;



// WEBPACK FOOTER //
// ./src/api.js